<template>
  <div :class="classModifiers">
    <div class="market-money-widget__title">{{ obj.title }}</div>
    <div class="market-money-widget__content" v-if="!!widget" @click.stop="onClick">
      <div class="market-money-widget__percent-container">
        <div class="market-money-widget__percent">{{ percent }}</div>
        <div class="market-money-widget__percent-title">
          <div class="market-money-widget__percent-vertical">{{ obj.percentTitle }}</div>
        </div>
      </div>
      <div class="market-money-widget__market">{{ obj.marketName }}</div>
      <div class="market-money-widget__contract">
        <div class="market-money-widget__contract-title">{{ contractName }}</div>
        <div class="market-money-widget__contract-section">
          <span class="market-money-widget__contract-price">
            <template v-if="hasPrice">
              <animated-number :value="price"></animated-number>
            </template>
            <template v-else> -<span v-html="'&cent;'"></span> </template>
          </span>
          <market-change-price class="market-money-widget__contract-delta" :price="delta" />
          <span v-if="hasPrice" :class="iconModifiers"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./market-money-widget.js"></script>
<style src="./market-money-widget.scss" lang="scss"></style>
